import Typography from '@mui/material/Typography';
import { ValuePlaceholder } from '@openx/components-core/lib/Value/ValuePlaceholder/ValuePlaceholder';

type LabeledValueProps = {
  dataTest?: string;
  label: string;
  value?: number | string | null;
  breakWord?: boolean;
  suffix?: string;
};

export const LabeledValue = ({ label, value, dataTest, breakWord = false, suffix = '' }: LabeledValueProps) => {
  return (
    <Typography data-test={dataTest}>
      <Typography color="textSecondary" component="span" variant="body2">
        {label}:
      </Typography>{' '}
      {value ? (
        <Typography component="span" sx={{ wordBreak: breakWord ? 'break-all' : 'keep-all' }} variant="body2">
          {value} {suffix}
        </Typography>
      ) : (
        <ValuePlaceholder />
      )}
    </Typography>
  );
};
